module.exports = __webpack_public_path__ + "static/img/1_0009.664aa8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0009.jpg
// module id = MjC4
// module chunks = 0